export default {
  //loding图状态
  isShow: false,
  // shopify app object 用于生成authornation
  shopifyAppObj: null,

  // 进度条
  NProgressObj: null,

  //店铺域名
  shopDomain: null,

  // 套餐id
  pricingPlanId: null,

  //货币符号
  currencySymbol: null,

  //套餐类型
  packagType: null,

  //是否开启我们app为默认拓展
  PostPurchaseActive: true,  //false 为没有开启  true为开启了

  //套餐权限
  role: null,

  post: {
    show: true,
    template: 2
  },

  userName: null,
  willDeskInfo: {}
}